<template>
  <div class="sidebar-menu-container">
    <div class="sidebar-menu" :class="{ smallLarge: menuActive === 3 || menuActive === 4 }">
      <ul id="list-menu">
        <li v-for="(item) in menus" :key="item.index" :class="{ active: menuActive === item.index }"
          :id="'menu' + item.index">

          <h4 :data-index="item.index">{{ item.name }}</h4>
          <h3 v-if="breadcrumb.roomSelected && item.index == 1 && breadcrumb.step >= 2">{{ breadcrumb.roomSelected }}
          </h3>
          <h3 v-if="breadcrumb.passionSelected && item.index == 2 && breadcrumb.step >= 2.5">
            {{ breadcrumb.passionSelected }}</h3>
          <h3 v-if="breadcrumb.featureSelected && item.index == 2 && breadcrumb.step >= 3">
            {{ breadcrumb.featureSelected }}</h3>
          <h3 v-if="breadcrumb.inchSelected && item.index == 3 && breadcrumb.step >= 4">
            <span v-if="breadcrumb.inchSelected[0] != breadcrumb.inchSelected[1]">
              Entre {{ breadcrumb.inchSelected[0] }} e {{ breadcrumb.inchSelected[1] }}
            </span>
            <span v-if="breadcrumb.inchSelected[0] == breadcrumb.inchSelected[1]">
              {{ breadcrumb.inchSelected[0] }}
            </span>
          </h3>
          <!-- <h3 v-else="breadcrumb.inchSelected    && item.index == 3 && breadcrumb.step >= 4">Entre {{breadcrumb.inchSelected[0]}} e {{breadcrumb.inchSelected[1]}}</h3> -->

        </li>
      </ul>
    </div>
    <NavigationButtons @clickNavigation="handleClickNavigation" :menuActive="this.menuActive" />
  </div>
</template>

<script>
import menus from '../constants/menus';
import NavigationButtons from '../components/NavigationButtons.vue';


export default {
  name: "SidebarMenu",
  components: {
    NavigationButtons
  },
  props: ["sendAnalytics", "menuActive", "userChoices", "operationNavigation", "breadcrumb"],
  data() {
    return {
      menus,
      valueToHorizontalScroll: 0,
      // breadcrumb:{
      //   roomSelected: "Sala de estar",
      //   passionSelected:"",
      //   featureSelected:"",
      //   inchSelected:"",
      //   step:1
      // }

    }
  },
  computed: {},
  mounted() { },
  methods: {
    handleClickNavigation(operation) {
      this.$emit('clickSidebar', operation);
    }
  },
  watch: {
    menuActive: {
      handler() {
        setTimeout(() => {
          document.getElementById(`menu${this.menuActive}`)
            .scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }, 1);

        if (this.menuActive == 5 || this.menuActive == 1) {
          this.breadcrumb.step = 1
        }
      }
    },
  }
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.sidebar-menu-container {

  background-color: #fff;
  position: absolute;
  top: calc(50% - 177px);
  left: 0;
  width: 280px;
  min-height: 330px;
  border-radius: 0px 1rem 1rem 0px;
  z-index: 2;
  // padding-bottom: 1rem;
  // border-top: medium solid #fff;
  // border-right: medium solid #fff;

  .navigation-buttons {
    display: flex;
    -webkit-box-shadow: initial;
    box-shadow: initial;
    border-radius: 0px 0px 16px 0px;
    position: initial;
    right: initial;
    bottom: initial;
    // padding: 0.5rem 0 0;
    // max-width: 149px;
    // margin: 0 auto;
  }

  .sidebar-menu {
    // background-color: $color-light-default;
    background-color: #F0F0F0;
    border-radius: 0px 1rem 1rem 0px;
    margin: 1% 1% 0 0;


    ul {
      max-width: 149px;
      margin: 0 auto;
      padding-bottom: 10%;

      li {
        padding: 1rem 0 0;
        display: inline-block;
        position: relative;
        min-height: 60px;
        min-width: 100%;
        border-bottom: 3px solid #fff;

        h4 {
          font-family: $font-family-subtitle;
          font-size: 1.25rem;
          color: $color-gray-extra-dark;
          padding-left: 1rem;

          &::before {
            display: block;
            content: attr(data-index);
            font-family: $font-family-subtitle;
            font-size: 1.25rem;
            color: $color-gray-extra-dark;
            position: absolute;
            left: 0;
          }
        }

        h3 {
          font-size: 12px;
          font-weight: 400;
          color: #2E2C2B;
          position: relative;
          padding-left: 1rem;

          &::before {
            content: "";
            display: block;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: $color-gray-extra-dark;
            position: absolute;
            left: 0;
            transform: translateY(-50%);
            top: 50%;
          }
        }
      }

      .active {
        border-bottom: 3px solid $color-primary;

        h4 {
          color: #2E2C2B;

          &::before {
            color: #2E2C2B;
          }
        }
      }
    }
  }
}

@media (max-width: $bp-mobile) {

  .sidebar-menu-container {

    top: 0;
    width: 100% !important;
    height: 75px;
    min-height: initial;
    background-color: $color-background;
    border-radius: 0;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    position: static;
    border-radius: none;

    div.navigation-buttons {
      display: none;
    }

    .sidebar-menu {
      margin: 0 0 1% 0;
      border-radius: 0px;
      width: 100% !important;
      background-color: $color-background;

      // overflow: auto;

      ul {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        max-width: initial;
        gap: 1rem;
        padding: 0 2rem 0 2rem;

        overflow-x: auto;
        -ms-overflow-style: none;
        /* Internet Explorer 10+ */
        scrollbar-width: none;
        /* Firefox */

        :first-child {
          color: $color-gray-extra-dark;
        }

        ;

        :last-child {
          color: $color-dark-default;
        }

        li {
          display: flex;
          justify-content: space-between;
          padding: 0.5rem .8rem 0.5rem 0;
          min-width: fit-content;
          align-items: center;
          position: relative;
          border-bottom: none;

          h3 {
            font-size: 12px;
            padding-left: 15px;
            margin-left: 10px;
            inline-size: max-content;
          }

          h4 {
            font-size: 14px;
          }

        }

        li:not(:last-child)::after {
          content: '';
          height: 18px;
          width: 2px;

          position: absolute;
          right: 0;
          top: 20px;

          background-color: #FFF;
        }

        li.active::before {
        content: '';
        display: block;
        height: 2px;
        width: 90%;
        background-color: $color-primary;
        position: absolute;
        bottom: 0;
      }

      .active{
        border-bottom: none;
      }

      }

      ul::-webkit-scrollbar {
        display: none;
        /* Safari and Chrome */
      }
    }
  }

  @media (max-width: 580px) {
    .sidebar-menu {
      ul {
        justify-content: flex-start;
      }
    }
  }

  @media (max-width: 1120px) {
    .smallLarge {
      width: 200px;
    }
  }
}
</style>
